// Utils
import { generateID } from "utils";

//Types
import { BCTeamsRef } from "services/pace/dashboard.service";
import { TTeam } from "../BehaviouralComparison.types";

export const convertTeamsRef = (data: BCTeamsRef[], selectedTeams: TTeam[]): TTeam[] => {
    const selectedTeamsNames = (selectedTeams || []).map((t) => t.name.toLowerCase());

    return data.map((el) => ({
        id: generateID(),
        label: el.name,
        name: el.name,
        count: el.count,
        checked: selectedTeamsNames.includes(el.name.toLowerCase()),
        users: el.users,
    }));
};
